export default __webpack_public_path__ + "static/media/lendoBanner.80d12eb9.png";